// Recherche du hero : suggestions de fiches produit pendant la frappe (Antoine, 02/10). Les
// fiches sont dans la page (JSON [data-anima-suggestions], Produits::suggestion()), sans appel
// au serveur. Liste ARIA « combobox » : flèches, Entrée, Échap. La liste est rattachée au
// <body> (le hero coupe ce qui dépasse) et placée sous le champ. Envoyé sans choisir, le
// formulaire garde son comportement : fiche unique ou catalogue filtré (Produits::rechercheDirecte).

const MOT_MIN = 2 // lettres, comme Produits::normaliser()
const MAX_SUGGESTIONS = 6
const ECART = 8 // px entre le champ et la liste
// Rangs : début du titre, titre, début d'un synonyme ou d'une gamme, mots-clés.
const RANG_DEBUT_TITRE = 4
const RANG_TITRE = 3
const RANG_TERME = 2
const RANG_CLES = 1
const MOTS_VIDES = ['de', 'du', 'des', 'la', 'le', 'les', 'en', 'et', 'au', 'aux', 'un', 'une', 'pour']

const mots = (texte) => texte.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
  .split(/[^a-z0-9]+/)
  .filter((m) => m.length >= MOT_MIN && !MOTS_VIDES.includes(m))
  .map((m) => m.replace(/s+$/, '') || m)
const normaliser = (texte) => mots(texte).join(' ')
// Chaque mot cherché commence un mot du texte (« fr » trouve « fraise », pas « afrique »).
const contientTout = (texte, liste) => {
  const debuts = texte.split(/[ |]+/)
  return liste.every((m) => debuts.some((d) => d.startsWith(m)))
}

const classer = (produits, saisie) => {
  const q = mots(saisie)
  if (!q.length) {
    return []
  }
  const debut = q.join(' ')
  return produits.map((p, ordre) => {
    const titre = normaliser(p.titre)
    let rang = 0
    let via = ''
    if (titre.startsWith(debut)) {
      rang = RANG_DEBUT_TITRE
    } else if (contientTout(titre, q)) {
      rang = RANG_TITRE
    } else {
      via = p.termes.find((t) => normaliser(t).startsWith(debut)) || ''
      if (via) {
        rang = RANG_TERME
      } else if (contientTout(p.cles, q)) {
        rang = RANG_CLES
        via = p.termes.find((t) => contientTout(normaliser(t), q)) || ''
      }
    }
    return {
      p,
      rang,
      via,
      ordre
    }
  })
    .filter((r) => r.rang)
    .sort((a, b) => b.rang - a.rang || a.ordre - b.ordre)
    .slice(0, MAX_SUGGESTIONS)
}

const el = (tag, classe, texte) => {
  const n = document.createElement(tag)
  if (classe) {
    n.className = classe
  }
  if (texte) {
    n.textContent = texte
  }
  return n
}

const init = (form) => {
  const input = form.querySelector('input[name="s"]')
  const donnees = form.querySelector('[data-anima-suggestions]')
  if (!input || !donnees) {
    return
  }
  let produits = []
  try {
    produits = JSON.parse(donnees.textContent)
  } catch {
    return
  }
  const liste = el('div', 'anima-suggestions')
  liste.id = input.getAttribute('aria-controls')
  liste.setAttribute('role', 'listbox')
  liste.setAttribute('aria-label', input.labels?.[0]?.textContent || '')
  liste.hidden = true
  document.body.append(liste)
  let options = []
  let actif = -1

  const placer = () => {
    const r = form.getBoundingClientRect()
    liste.style.top = `${r.bottom + window.scrollY + ECART}px`
    liste.style.left = `${r.left + window.scrollX}px`
    liste.style.width = `${r.width}px`
  }

  const fermer = () => {
    liste.hidden = true
    input.setAttribute('aria-expanded', 'false')
    input.removeAttribute('aria-activedescendant')
    actif = -1
  }

  const activer = (i) => {
    options.forEach((o, n) => o.setAttribute('aria-selected', n === i ? 'true' : 'false'))
    actif = i
    if (i >= 0) {
      input.setAttribute('aria-activedescendant', options[i].id)
      options[i].scrollIntoView({
        block: 'nearest'
      })
    } else {
      input.removeAttribute('aria-activedescendant')
    }
  }

  const option = (lien, n) => {
    const o = el('a', 'anima-suggestion')
    o.href = lien
    o.id = `${liste.id}-${n}`
    o.setAttribute('role', 'option')
    o.setAttribute('aria-selected', 'false')
    o.tabIndex = -1
    o.addEventListener('mousemove', () => activer(n))
    return o
  }

  const afficher = () => {
    const saisie = input.value.trim()
    const resultats = classer(produits, saisie)
    liste.replaceChildren()
    options = []
    if (!mots(saisie).length) {
      fermer()
      return
    }
    resultats.forEach(({
      p, via
    }, n) => {
      const o = option(p.lien, n)
      const vignette = el('span', 'anima-suggestion-img')
      if (p.image) {
        const img = el('img')
        img.src = p.image
        img.alt = ''
        img.loading = 'lazy'
        vignette.append(img)
      }
      const txt = el('span', 'anima-suggestion-txt')
      txt.append(el('strong', '', p.titre))
      const detail = [via ? form.dataset.via.replace('%s', via) : '', p.origines].filter(Boolean).join(' · ')
      if (detail) {
        txt.append(el('span', '', detail))
      }
      o.append(vignette, txt)
      if (p.propre) {
        o.append(el('span', 'anima-suggestion-badge', form.dataset.propre))
      }
      options.push(o)
    })
    // Dernière ligne : tous les résultats (catalogue filtré), ou le catalogue si rien ne correspond.
    const tout = option('#', options.length)
    tout.classList.add('anima-suggestion-tout')
    tout.textContent = (resultats.length ? form.dataset.tout : form.dataset.aucun).replace('%s', saisie)
    tout.addEventListener('click', (e) => {
      e.preventDefault()
      form.requestSubmit()
    })
    options.push(tout)
    liste.append(...options)
    placer()
    liste.hidden = false
    input.setAttribute('aria-expanded', 'true')
    activer(-1)
  }

  input.addEventListener('input', afficher)
  input.addEventListener('focus', () => {
    if (input.value.trim()) {
      afficher()
    }
  })
  input.addEventListener('keydown', (e) => {
    if (liste.hidden) {
      return
    }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault()
      // Cycle : champ (-1), options, retour au champ.
      let suivant = actif + (e.key === 'ArrowDown' ? 1 : -1)
      if (suivant >= options.length) {
        suivant = -1
      } else if (suivant < -1) {
        suivant = options.length - 1
      }
      activer(suivant)
    } else if (e.key === 'Enter' && actif >= 0) {
      e.preventDefault()
      options[actif].click()
    } else if (e.key === 'Escape') {
      fermer()
    }
  })
  document.addEventListener('pointerdown', (e) => {
    if (!form.contains(e.target) && !liste.contains(e.target)) {
      fermer()
    }
  })
  // WP Rocket retarde les scripts jusqu'à la première interaction : si la saisie a commencé
  // avant, la liste s'ouvre dès le démarrage.
  if (document.activeElement === input && input.value.trim()) {
    afficher()
  }
  window.addEventListener('resize', () => {
    if (!liste.hidden) {
      placer()
    }
  })
}

const boot = () => document.querySelectorAll('[data-anima-recherche]').forEach(init)

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
